import { configureStore } from "@reduxjs/toolkit";
import login from "../redux/slices/auth";
import signup from "../redux/slices/signup";
import verify from "../redux/slices/verify";
import getgames from "../redux/slices/ggame";
import Create from "../redux/slices/createUser";
import reset from "../redux/slices/resetpass";
import cradit from "../redux/slices/cradit";
import radeem from "../redux/slices/radeem";
import loading from "../redux/slices/loading";
import Balance from "../redux/slices/getbalance";
import uBalance from "../redux/slices/userbal";
import payment from "../redux/slices/payment";
import Tabs from "../redux/slices/bottomtab";
import udeposit from "../redux/slices/depositlist";
import gamehistory from "./slices/gamehistory";
import cashout from "./slices/cashoutreq";
import selfie from "./slices/profile";
import resets from "./slices/resets";
import transpicture from "./slices/transpicture";
import AccountTypes from "./slices/accountoptions";
import gift from "./slices/gift";
import coin from "./slices/coinSlice";
import paymentmethod from "./slices/paymentmethod";
import userinterface from "./slices/interface";

export default configureStore({
  reducer: {
    login: login,
    signup: signup,
    verify: verify,
    games: getgames,
    usercreate: Create,
    reset: reset,
    cradit: cradit,
    radeem: radeem,
    load: loading,
    up: Balance,
    ubal: uBalance,
    bank: payment,
    tabs: Tabs,
    dplist: udeposit,
    gh: gamehistory,
    cash: cashout,
    selfie: selfie,
    resets: resets,
    transpic: transpicture,
    accountsTypes: AccountTypes,
    gift: gift,
    coin: coin,
    paymentmethod: paymentmethod,
    interface: userinterface,
  },
});
